// extracted by mini-css-extract-plugin
export var searchHeader = "_6c-0";
export var searchHeaderDark = "_6c-1";